import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/mediabook/mediabook/src/templates/Standalone.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`14. 5-10 year vision`}</h2>
    <p>{`The final sections of this document should be considered as a thought experiment rather than a
thesis. It is impractical to predict so far into the future for a young organization, though an
attempt to do so may providing insight into how it might develop, and at the least the broad
direction we are aiming to grow.`}</p>
    <p>{`One of the underlying predictions behind our work at Make School - and interest in inspiring a new
category of institutions - is that the economy is being largely reshaped by the software revolution.
The gains of technology - and the real world possibilities created - have made many well-developed
business models obsolete. We’re entering a world where large corporations (largely funded by a
recent boom in venture capital) are being born within a decade by providing higher quality at a
lower cost to consumers. These businesses - if designed ethically - have potential to create equity
and improve quality of life globally.`}</p>
    <p>{`We see Make School, and institutions like us, creating a robust talent pipeline for this new genre
of organization. These organizations require a new mold of worker: self-driven, autonomous,
passionate, vulnerable, empathetic, and ethical. Work is not a means to an end but a purpose,
colleagues are not acquaintances but a community. Our aim is to develop and support a generation of
talent to found and join organizations building a better and more equitable future.`}</p>
    <p>{`Over the next decade, we expect to expand our courses of study beyond computer science, to computing
adjacent fields where new products and services are being born. We’ll look to introduce
specializations in design and human-computer interaction, robotics, cognition and artificial
intelligence, biotech, and more. We hope to build out an urban campus in San Francisco, before
expanding to New York City, and additional economic hubs around the world, allowing students to
study across locations.`}</p>
    <p>{`We’d want systems and software to loosely govern our network of campuses, ensuring enough agency for
individual instructors and administrators to experiment with new models of education and new
curricula to better support local students and industry. We expect our instructors to maintain heavy
industry ties, some as adjuncts and some serving a multi-year “tour of duty” prior to taking the
next step in their professional careers or founding their next startup. Our students will contribute
to open source projects under the guidance of industry professionals, ensuring relevance of their
education and enabling their work to create value for the world.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      